// @ts-nocheck
import { useLayoutEffect, useState } from 'react';
import axios from 'axios';
import { useAtomValue } from 'jotai';

import { languageAtom } from '@shared/store/slice-atoms';
import Config from '@shared/config/constants/config-main';
import { appendTextScript } from '@shared/utils/general';
import { useQuery } from '@shared/hooks';
import { OTPRedirectionDetails } from '@features/otp-verification/model/types';

// The direct-redirect variant arrives on the OTP page from an external
// partner MSISDN page. It needs to call /home/subscribe/redirection/details
// before the user can submit anything because the session id, price and
// antifraud token live behind that endpoint.
export const useOTPRedirectionDetails = (enabled: boolean) => {
  const [redirectionDetails, setRedirectionDetails] = useState<OTPRedirectionDetails>({});
  const [antifraudUniqueId, setAntifraudUniqueId] = useState<string | null>(null);

  const language = useAtomValue(languageAtom);
  const { query } = useQuery();
  const sessionId = query.get('sessionId') || null;

  const loadDetails = async () => {
    const body = {
      sessionId,
      lang: language?.locale || 'en',
    };

    const { data: resData } = await axios.post(
      `${Config.API_URL}/home/subscribe/redirection/details`,
      body
    );

    const responseData = resData?.data || null;
    if (!responseData) return;

    appendTextScript(responseData.apiSubscribeServiceID, 0);
    setAntifraudUniqueId(responseData?.antiFraudUniqueId || null);
    setRedirectionDetails(responseData);

    window.history.replaceState(null, '', window.location.pathname);
  };

  useLayoutEffect(() => {
    if (!enabled) return;
    loadDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return {
    redirectionDetails,
    antifraudUniqueId,
    setAntifraudUniqueId,
  };
};
